import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../config/design/TableIcons";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../../config/Permissions";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import AppCardLoaderTable from "../../../components/Skeletons/AppCardLoaderTable";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {changeURL, currencySymbol, price} from "../../../../config/values";
import Button from "@material-ui/core/Button/Button";
import { Link as ReactLink } from "react-router-dom";
import FilterListRoundedIcon from "@material-ui/icons/FilterListRounded";
import {Grid, MenuItem} from "@material-ui/core";
import TextField from "@material-ui/core/TextField/TextField";
import queryString from "query-string";

class Orders extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            {
                field: 'buyer',
                editable: 'never',
                filtering: false,
                title: Translate.buyer,
            },
            {
                field: 'factor_number',
                editable: 'never',
                filtering: false,
                title: Translate.factor_number,
            },
            { title: Translate.totalPriceFull,
                field: 'total_price_payed',
                filterPlaceholder: Translate.search,
            },

            { title: Translate.totalUserDiscounts,
                field: 'total_discounts',
                filterPlaceholder: Translate.search,
            },
            { title: Translate.commission,
                field: 'commission',
                filterPlaceholder: Translate.search,
            },
            { title: Translate.status,
                editable: 'never',
                field: 'status',
                filterPlaceholder: Translate.choose,
                lookup: {
                    "done" :
                        <Typography className="order_badge" style={{backgroundColor: "#38bf84"}}>{Translate.done}</Typography>
                    , "rejected":
                        <Typography className="order_badge" style={{backgroundColor: "#580808"}}>{Translate.rejected}</Typography>
                    , "sending":
                        <Typography className="order_badge" style={{backgroundColor: "#3867bf"}}>{Translate.sending}</Typography>
                    , "gathering":
                        <Typography className="order_badge" style={{backgroundColor: "#3899bf"}}>{Translate.gathering}</Typography>
                    , "not_payed":
                        <Typography className="order_badge" style={{backgroundColor: "#ee0e0e"}}>{Translate.not_payed}</Typography>
                    , "need_verification":
                        <Typography className="order_badge" style={{backgroundColor: "#fc771f"}}>{Translate.need_verification}</Typography>
                },
            },
            { title: Translate.created_at_factor,
                editable: 'never',
                filtering: false,
                field: 'created_at',
                render: rowData =>
                    <Typography className="date_in_table">
                        {`${moment(rowData.created_at).locale('fa').fromNow()}`}
                        <br/>
                        {`${moment(rowData.created_at).locale('fa').format( 'YYYY/M/D')}`}
                    </Typography>
            },
            {
                title: Translate.activity,
                field: 'activity',
                render: rowData =>
                    <>
                        <Button
                            color="primary"
                            size="small"
                            variant="outlined"
                            component={ReactLink}
                            to={`/order/manage/${rowData.id}`}
                        >
                            {Translate.view}
                        </Button>
                        {
                            (rowData.status === "not_payed" || rowData.status === "need_verification")  &&
                            <Button
                                className="mx-5"
                                onClick={() => this.handleRemoveItem(rowData.id)}
                                size="small"
                                style={{color:"#f82e4e",marginRight:5}}
                            >
                                {Translate.remove}
                            </Button>
                        }
                    </>
            }
        ],
        data: [],
        status: 'all',
        date: 'all',
        loading:false,
        ChangeLoader:false
    };
    async componentDidMount(){
        await this.loadDefaults();
    }
    componentWillUnmount(){
        changeURL({search: this.state.search})
    }
    async loadDefaults(){
        const values = queryString.parse(window.location.search);
        let status = values.status;
        let date = values.date;
        let page = values.page;
        let per_page = values.per_page;
        let order_by = values.order_by;
        let order_dir = values.order_dir;
        if(!!status){
            await this.setState({
                status,
            })
        }
        if(!!date){
            await this.setState({
                date,
            })
        }
        if(!!page){
            await this.setState({
                def_page:page,
            })
        }
        if(!!per_page){
            await this.setState({
                per_page:per_page,
                def_per_page:per_page,
            })
        }
        if(!!order_by){
            await this.setState({
                order_by:order_by,
                order_dir:order_dir,
            })
        }
        await this.setState({
            loading:false,
        })
    }
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    handleRemoveItem(id){
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/factor/remove`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.dataRemoved, {
                    variant: 'success',
                });
                this.loadData();
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.dataRemovingFailed, {
                    variant: 'error',
                });

            });

        this.setState({
            loading:false,
            SubmitLoading:false
        });
    }
    async handleChangeStatus(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let status = target.value;
        await this.setState({
            status
        });
        changeURL({status: target.value});
        this.loadData();
    }
    async handleChangeDate(e) {
        this.setState({
            ChangeLoader:true
        })
        let target = e.target;
        let date = target.value;
        await this.setState({
            date
        });
        changeURL({date: target.value});
        this.loadData();
    }
    render(){
        let {status,date} = this.state;
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl" className={!!this.props.widget ? "thin-table" : null}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} >
                                    <Grid container spacing={2} alignItems="center" direction="row" className={this.classes.filterContainer}>
                                        <Grid item xs={12} md={3} lg={1}>
                                            <Typography>
                                                <FilterListRoundedIcon/>
                                                {Translate.filters}:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={3} lg={2}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label={Translate.status}
                                                variant="outlined"
                                                value={status}
                                                onChange={this.handleChangeStatus.bind(this)}
                                            >
                                                <MenuItem value={"done"}>{Translate.done}</MenuItem>
                                                <MenuItem value={"sending"}>{Translate.sending}</MenuItem>
                                                <MenuItem value={"gathering"}>{Translate.gathering}</MenuItem>
                                                <MenuItem value={"rejected"}>{Translate.rejected}</MenuItem>
                                                <MenuItem value={"not_payed"}>{Translate.not_payed}</MenuItem>
                                                <MenuItem value='need_verification'>{Translate.need_verification}</MenuItem>
                                                <MenuItem value='all'>{Translate.all}</MenuItem>

                                            </TextField>
                                        </Grid>
                                        <Grid item xs={12} md={3} lg={2}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                value={date}
                                                label={Translate.chooseDate}
                                                onChange={this.handleChangeDate.bind(this)}
                                            >
                                                <MenuItem value='today'>{Translate.today}</MenuItem>
                                                <MenuItem value='this_week'>{Translate.this_week}</MenuItem>
                                                <MenuItem value='this_month'>{Translate.this_month}</MenuItem>
                                                <MenuItem value='all'>{Translate.all}</MenuItem>
                                            </TextField>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <MaterialTable
                                        tableRef={this.tableRef}
                                        icons={tableIcons}
                                        title={" "}
                                        localization={DataTableLocalization}
                                        columns={this.state.columns}
                                        data={query =>
                                            new Promise((resolve, reject) => {
                                                axios.get(`${defaultVariabls.url}/factors/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}&status=${status}&date=${date}`, config)
                                                    .then(response => {
                                                        let data = [];
                                                        // eslint-disable-next-line
                                                        response.data.data.map((row) => {
                                                            data.push({
                                                                total_price_payed: price(row.total_price_payed) +" "+currencySymbol,
                                                                id: row.id,
                                                                factor_number: row.number,
                                                                buyer: row.user.first_name +" "+row.user.last_name,
                                                                total_discounts: price(row.total_discount_code_price + row.total_discount_price) +" "+currencySymbol,
                                                                commission: price(row.commission) +" "+currencySymbol,
                                                                status: row.status,
                                                                created_at: row.created_at,
                                                            })
                                                        });
                                                        resolve({
                                                            data: data,
                                                            page: response.data.current_page - 1,
                                                            totalCount: response.data.total,
                                                        })
                                                    }).catch(error => {
                                                    console.log(error.response)
                                                })
                                            })
                                        }
                                        options={{
                                            pageSize: TablePage,
                                            pageSizeOptions: TableCount,
                                            /*search:false,*/
                                        }}
                                    />
                                </Grid>
                            </Grid>

                        </Container>
                }
            </>

        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Orders)))));